// ============================================================================
// OBT F2-B — Hata normalizasyonu (paket-yerel ince katman)
// ============================================================================
// Ortak `normalizeObtError` READ-ONLY kullanılır; yalnız F2-B'ye özel 413/415
// (medya) durumları ve akış-özel mesajlar burada eklenir. Ham traceback,
// storage path, UUID veya kontrolsüz backend gövdesi ASLA gösterilmez.
// ============================================================================

import { normalizeObtError, OBT_ERROR_KIND } from '../obtErrors';

const F2B_MESSAGES = Object.freeze({
  413: 'Dosya boyutu sınırı (10 MB) aşıldı.',
  415: 'Desteklenmeyen dosya türü.',
});

/**
 * Axios hatasını F2-B arayüzünün güvenle gösterebileceği şekle indirger.
 * @returns {{status: number|null, kind: string, message: string}}
 */
export function normalizeResponseError(error) {
  const status = error?.response?.status ?? null;
  if (status === 413 || status === 415) {
    return { status, kind: 'media', message: F2B_MESSAGES[status] };
  }
  return normalizeObtError(error);
}

export function isConflict(normalized) {
  return normalized?.kind === OBT_ERROR_KIND.CONFLICT || normalized?.status === 409;
}
export function isForbidden(normalized) {
  return normalized?.kind === OBT_ERROR_KIND.FORBIDDEN || normalized?.status === 403;
}
export function isNotFound(normalized) {
  return normalized?.kind === OBT_ERROR_KIND.NOT_FOUND || normalized?.status === 404;
}

export { OBT_ERROR_KIND };
